const initialState = {
    // addOrder: true,
    permissions: {},

  };
  
  const PagePermissionReducer = (state = initialState, action:any) => {
    // switch (action.type) {
    //   case 'SET_PERMISSION':
    //     return {
    //       ...state,
    //       addOrder: action.payload,
    //     };
    //   default:
    //     return state;
    // }
    switch (action.type) {
        case 'SET_PERMISSION':
          const permissions = action.payload;
          const permissionState = {};
    
          permissions.forEach((section) => {
            if (section.subitems && section.subitems.length > 0) {
              section.subitems.forEach((subitem) => {
                permissionState[subitem.title] = subitem.permisssions;
              });
            }
          });
    
          return {
            ...state,
            permissions: permissionState,
          };
        default:
          return state;
      }
  };
  
  export default PagePermissionReducer;
  